// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TaskAction-module_task-action__k9a_D{margin-top:40px}`, "",{"version":3,"sources":["webpack://./src/App/views/Task/components/TaskAction.module.scss"],"names":[],"mappings":"AAAA,sCAAa,eAAe","sourcesContent":[".task-action{margin-top:40px}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"task-action": `TaskAction-module_task-action__k9a_D`
};
export default ___CSS_LOADER_EXPORT___;
